module.exports = __webpack_public_path__ + "static/media/virksomhed_card.4758c7b3.jpg";